import productCardErrorImg from './icons/productCardErrorImg.png';
import productCardErrorImg2x from './icons/productCardErrorImg@2x.png';
import productCardErrorImg3x from './icons/productCardErrorImg@3x.png';

import chiefHat from './icons/chiefHat.png';
import chiefHat2x from './icons/chiefHat@2x.png';
import chiefHat3x from './icons/chiefHat@3x.png';

import chiefHatRed from './icons/chiefHatRed.png';
import chiefHatRed2x from './icons/chiefHatRed@2x.png';
import chiefHatRed3x from './icons/chiefHatRed@3x.png';

import info from './icons/info.png';
import info2x from './icons/info@2x.png';
import info3x from './icons/info@3x.png';

import gift from './icons/gift.png';
import gift2x from './icons/gift@2x.png';
import gift3x from './icons/gift@3x.png';

import infoOutlined from './icons/infoOutlined.png';
import infoOutlined2x from './icons/infoOutlined@2x.png';
import infoOutlined3x from './icons/infoOutlined@3x.png';

import giftRed from './icons/giftRed.png';
import giftRed2x from './icons/giftRed@2x.png';
import giftRed3x from './icons/giftRed@3x.png';

import infoRed from './icons/infoRed.png';
import infoRed2x from './icons/infoRed@2x.png';
import infoRed3x from './icons/infoRed@3x.png';

import infoGrey from './icons/infoGrey.png';
import infoGrey2x from './icons/infoGrey@2x.png';
import infoGrey3x from './icons/infoGrey@3x.png';

import personOutlined from './icons/personOutlined.png';
import personOutlined2x from './icons/personOutlined@2x.png';
import personOutlined3x from './icons/personOutlined@3x.png';

import questionCircled from './icons/questionCircled.png';
import questionCircled2x from './icons/questionCircled@2x.png';
import questionCircled3x from './icons/questionCircled@3x.png';

import questionCircledRed from './icons/questionCircledRed.png';
import questionCircledRed2x from './icons/questionCircledRed@2x.png';
import questionCircledRed3x from './icons/questionCircledRed@3x.png';

import questionCircledLightGrey from './icons/questionCircledLightGrey.png';
import questionCircledLightGrey2x from './icons/questionCircledLightGrey@2x.png';
import questionCircledLightGrey3x from './icons/questionCircledLightGrey@3x.png';

import starOutlined from './icons/starOutlined.png';
import starOutlined2x from './icons/starOutlined@2x.png';
import starOutlined3x from './icons/starOutlined@3x.png';

import starOutlinedRed from './icons/starOutlinedRed.png';
import starOutlinedRed2x from './icons/starOutlinedRed@2x.png';
import starOutlinedRed3x from './icons/starOutlinedRed@3x.png';

import starOutlinedLightGrey from './icons/starOutlinedLightGrey.png';
import starOutlinedLightGrey2x from './icons/starOutlinedLightGrey@2x.png';
import starOutlinedLightGrey3x from './icons/starOutlinedLightGrey@3x.png';

import videoCircled from './icons/videoCircled.png';
import videoCircled2x from './icons/videoCircled@2x.png';
import videoCircled3x from './icons/videoCircled@3x.png';

import videoCircledRed from './icons/videoCircledRed.png';
import videoCircledRed2x from './icons/videoCircledRed@2x.png';
import videoCircledRed3x from './icons/videoCircledRed@3x.png';

import radioButtonOn from './icons/radioButtonOn.png';
import radioButtonOn2x from './icons/radioButtonOn@2x.png';
import radioButtonOn3x from './icons/radioButtonOn@3x.png';

import radioButtonOnGreen from './icons/radioButtonOnGreen.png';
import radioButtonOnGreen2x from './icons/radioButtonOnGreen@2x.png';
import radioButtonOnGreen3x from './icons/radioButtonOnGreen@3x.png';

import minusLightGrey from './icons/minusLightGrey.png';
import minusLightGrey2x from './icons/minusLightGrey@2x.png';
import minusLightGrey3x from './icons/minusLightGrey@3x.png';

import plusRed from './icons/plusRed.png';
import plusRed2x from './icons/plusRed@2x.png';
import plusRed3x from './icons/plusRed@3x.png';

import weight from './icons/weight.png';
import weight2x from './icons/weight@2x.png';
import weight3x from './icons/weight@3x.png';

import weightRed from './icons/weightRed.png';
import weightRed2x from './icons/weightRed@2x.png';
import weightRed3x from './icons/weightRed@3x.png';

import heartOutlined from './icons/heartOutlined.png';
import heartOutlined2x from './icons/heartOutlined@2x.png';
import heartOutlined3x from './icons/heartOutlined@3x.png';

import heartFilled from './icons/heartFilled.png';
import heartFilled2x from './icons/heartFilled@2x.png';
import heartFilled3x from './icons/heartFilled@3x.png';

import heartFilledRed from './icons/heartFilledRed.png';
import heartFilledRed2x from './icons/heartFilledRed@2x.png';
import heartFilledRed3x from './icons/heartFilledRed@3x.png';

import shareOutlined from './icons/shareOutlined.png';
import shareOutlined2x from './icons/shareOutlined@2x.png';
import shareOutlined3x from './icons/shareOutlined@3x.png';

import homeOutlined from './icons/homeOutlined.png';
import homeOutlined2x from './icons/homeOutlined@2x.png';
import homeOutlined3x from './icons/homeOutlined@3x.png';

import pinOutlined from './icons/pinOutlined.png';
import pinOutlined2x from './icons/pinOutlined@2x.png';
import pinOutlined3x from './icons/pinOutlined@3x.png';

import checkmarkOutlinedGreen from './icons/checkmarkOutlinedGreen.png';
import checkmarkOutlinedGreen2x from './icons/checkmarkOutlinedGreen@2x.png';
import checkmarkOutlinedGreen3x from './icons/checkmarkOutlinedGreen@3x.png';

import creditCardIncomeOutlined from './icons/creditCardIncomeOutlined.png';
import creditCardIncomeOutlined2x from './icons/creditCardIncomeOutlined@2x.png';
import creditCardIncomeOutlined3x from './icons/creditCardIncomeOutlined@3x.png';

import creditCardOutcomeOutlinedRed from './icons/creditCardOutcomeOutlinedRed.png';
import creditCardOutcomeOutlinedRed2x from './icons/creditCardOutcomeOutlinedRed@2x.png';
import creditCardOutcomeOutlinedRed3x from './icons/creditCardOutcomeOutlinedRed@3x.png';

import creditCardOutcomeOutlinedGrey from './icons/creditCardOutcomeOutlinedGrey.png';
import creditCardOutcomeOutlinedGrey2x from './icons/creditCardOutcomeOutlinedGrey@2x.png';
import creditCardOutcomeOutlinedGrey3x from './icons/creditCardOutcomeOutlinedGrey@3x.png';

import creditCardOutcomeOutlinedGreen from './icons/creditCardOutcomeOutlinedGreen.png';
import creditCardOutcomeOutlinedGreen2x from './icons/creditCardOutcomeOutlinedGreen@2x.png';
import creditCardOutcomeOutlinedGreen3x from './icons/creditCardOutcomeOutlinedGreen@3x.png';

import carOutlined from './icons/carOutlined.png';
import carOutlined2x from './icons/carOutlined@2x.png';
import carOutlined3x from './icons/carOutlined@3x.png';

import cartOutlined from './icons/cartOutlined.png';
import cartOutlined2x from './icons/cartOutlined@2x.png';
import cartOutlined3x from './icons/cartOutlined@3x.png';
import shareFilled from './icons/shareFilled.png';
import shareFilled2x from './icons/shareFilled@2x.png';
import shareFilled3x from './icons/shareFilled@3x.png';

import shareFilledRed from './icons/shareFilledRed.png';
import shareFilledRed2x from './icons/shareFilledRed@2x.png';
import shareFilledRed3x from './icons/shareFilledRed@3x.png';

import thumbsUpOutlinedGrey from './icons/thumbsUpOutlinedGrey.png';
import thumbsUpOutlinedGrey2x from './icons/thumbsUpOutlinedGrey@2x.png';
import thumbsUpOutlinedGrey3x from './icons/thumbsUpOutlinedGrey@3x.png';

import thumbsUpOutlinedGreen from './icons/thumbsUpOutlinedGreen.png';
import thumbsUpOutlinedGreen2x from './icons/thumbsUpOutlinedGreen@2x.png';
import thumbsUpOutlinedGreen3x from './icons/thumbsUpOutlinedGreen@3x.png';

import thumbsDownOutlinedGrey from './icons/thumbsDownOutlinedGrey.png';
import thumbsDownOutlinedGrey2x from './icons/thumbsDownOutlinedGrey@2x.png';
import thumbsDownOutlinedGrey3x from './icons/thumbsDownOutlinedGrey@3x.png';

import thumbsDownOutlinedRed from './icons/thumbsDownOutlinedRed.png';
import thumbsDownOutlinedRed2x from './icons/thumbsDownOutlinedRed@2x.png';
import thumbsDownOutlinedRed3x from './icons/thumbsDownOutlinedRed@3x.png';

import bellOutlined from './icons/bellOutlined.png';
import bellOutlined2x from './icons/bellOutlined@2x.png';
import bellOutlined3x from './icons/bellOutlined@3x.png';

import bellFilled from './icons/bellFilled.png';
import bellFilled2x from './icons/bellFilled@2x.png';
import bellFilled3x from './icons/bellFilled@3x.png';

import bellFilledRed from './icons/bellFilledRed.png';
import bellFilledRed2x from './icons/bellFilledRed@2x.png';
import bellFilledRed3x from './icons/bellFilledRed@3x.png';

import trashOutlinedGrey from './icons/trashOutlinedGrey.png';
import trashOutlinedGrey2x from './icons/trashOutlinedGrey@2x.png';
import trashOutlinedGrey3x from './icons/trashOutlinedGrey@3x.png';

import editOutlinedGrey from './icons/editOutlinedGrey.png';
import editOutlinedGrey2x from './icons/editOutlinedGrey@2x.png';
import editOutlinedGrey3x from './icons/editOutlinedGrey@3x.png';

import editOutlinedRed from './icons/editOutlinedRed.png';
import editOutlinedRed2x from './icons/editOutlinedRed@2x.png';
import editOutlinedRed3x from './icons/editOutlinedRed@3x.png';

import editOutlinedLightRed from './icons/editOutlinedLightRed.png';
import editOutlinedLightRed2x from './icons/editOutlinedLightRed@2x.png';
import editOutlinedLightRed3x from './icons/editOutlinedLightRed@3x.png';

import clockOutlinedRed from './icons/clockOutlinedRed.png';
import clockOutlinedRed2x from './icons/clockOutlinedRed@2x.png';
import clockOutlinedRed3x from './icons/clockOutlinedRed@3x.png';
import archiveOutlined from './icons/archiveOutlined.png';
import archiveOutlined2x from './icons/archiveOutlined@2x.png';
import archiveOutlined3x from './icons/archiveOutlined@3x.png';

import archiveOutlinedRed from './icons/archiveOutlinedRed.png';
import archiveOutlinedRed2x from './icons/archiveOutlinedRed@2x.png';
import archiveOutlinedRed3x from './icons/archiveOutlinedRed@3x.png';

import checkSquareOutlined from './icons/checkSquareOutlined.png';
import checkSquareOutlined2x from './icons/checkSquareOutlined@2x.png';
import checkSquareOutlined3x from './icons/checkSquareOutlined@3x.png';

import checkSquareOutlinedRed from './icons/checkSquareOutlinedRed.png';
import checkSquareOutlinedRed2x from './icons/checkSquareOutlinedRed@2x.png';
import checkSquareOutlinedRed3x from './icons/checkSquareOutlinedRed@3x.png';

import clockFilledWhite from './icons/clockFilledWhite.png';
import clockFilledWhite2x from './icons/clockFilledWhite@2x.png';
import clockFilledWhite3x from './icons/clockFilledWhite@3x.png';

import awardFilledGrey from './icons/awardFilledGrey.png';
import awardFilledGrey2x from './icons/awardFilledGrey@2x.png';
import awardFilledGrey3x from './icons/awardFilledGrey@3x.png';

import checkmarkFilledCircleWhite from './icons/checkmarkFilledCircleWhite.png';
import checkmarkFilledCircleWhite2x from './icons/checkmarkFilledCircleWhite@2x.png';
import checkmarkFilledCircleWhite3x from './icons/checkmarkFilledCircleWhite@3x.png';

import bookmarkOutlined from './icons/bookmarkOutlined.png';
import bookmarkOutlined2x from './icons/bookmarkOutlined@2x.png';
import bookmarkOutlined3x from './icons/bookmarkOutlined@3x.png';

import bookmarkOutlinedRed from './icons/bookmarkOutlinedRed.png';
import bookmarkOutlinedRed2x from './icons/bookmarkOutlinedRed@2x.png';
import bookmarkOutlinedRed3x from './icons/bookmarkOutlinedRed@3x.png';

import calendarFilledDarkGrey from './icons/calendarFilledDarkGrey.png';
import calendarFilledDarkGrey2x from './icons/calendarFilledDarkGrey@2x.png';
import calendarFilledDarkGrey3x from './icons/calendarFilledDarkGrey@3x.png';

import checkmarkWhite from './icons/checkmarkWhite.png';
import checkmarkWhite2x from './icons/checkmarkWhite@2x.png';
import checkmarkWhite3x from './icons/checkmarkWhite@3x.png';

import cartFilledDarkGrey from './icons/cartFilledDarkGrey.png';
import cartFilledDarkGrey2x from './icons/cartFilledDarkGrey@2x.png';
import cartFilledDarkGrey3x from './icons/cartFilledDarkGrey@3x.png';

import cameraOutlinedLightGrey from './icons/cameraOutlinedLightGrey.png';
import cameraOutlinedLightGrey2x from './icons/cameraOutlinedLightGrey@2x.png';
import cameraOutlinedLightGrey3x from './icons/cameraOutlinedLightGrey@3x.png';

import alertCircleOrange from './icons/alertCircleOrange.png';
import alertCircleOrange2x from './icons/alertCircleOrange@2x.png';
import alertCircleOrange3x from './icons/alertCircleOrange@3x.png';

import personDoneFilledDarkGrey from './icons/personDoneFilledDarkGrey.png';
import personDoneFilledDarkGrey2x from './icons/personDoneFilledDarkGrey@2x.png';
import personDoneFilledDarkGrey3x from './icons/personDoneFilledDarkGrey@3x.png';

import personDoneOutlinedLightGrey from './icons/personDoneOutlinedLightGrey.png';
import personDoneOutlinedLightGrey2x from './icons/personDoneOutlinedLightGrey@2x.png';
import personDoneOutlinedLightGrey3x from './icons/personDoneOutlinedLightGrey@3x.png';

import personDoneOutlinedRed from './icons/personDoneOutlinedRed.png';
import personDoneOutlinedRed2x from './icons/personDoneOutlinedRed@2x.png';
import personDoneOutlinedRed3x from './icons/personDoneOutlinedRed@3x.png';

import shoppingbagFilledDarkGrey from './icons/shoppingbagFilledDarkGrey.png';
import shoppingbagFilledDarkGrey2x from './icons/shoppingbagFilledDarkGrey@2x.png';
import shoppingbagFilledDarkGrey3x from './icons/shoppingbagFilledDarkGrey@3x.png';

import undoOutlinedDarkGrey from './icons/undoOutlinedDarkGrey.png';
import undoOutlinedDarkGrey2x from './icons/undoOutlinedDarkGrey@2x.png';
import undoOutlinedDarkGrey3x from './icons/undoOutlinedDarkGrey@3x.png';

import undoOutlinedRed from './icons/undoOutlinedRed.png';
import undoOutlinedRed2x from './icons/undoOutlinedRed@2x.png';
import undoOutlinedRed3x from './icons/undoOutlinedRed@3x.png';

import undoFilledCircleRed from './icons/undoFilledCircleRed.png';
import undoFilledCircleRed2x from './icons/undoFilledCircleRed@2x.png';
import undoFilledCircleRed3x from './icons/undoFilledCircleRed@3x.png';

import bookmarkFilledRed from './icons/bookmarkFilledRed.png';
import bookmarkFilledRed2x from './icons/bookmarkFilledRed@2x.png';
import bookmarkFilledRed3x from './icons/bookmarkFilledRed@3x.png';

import chevronLeftRed from './icons/chevronLeftRed.png';
import chevronLeftRed2x from './icons/chevronLeftRed@2x.png';
import chevronLeftRed3x from './icons/chevronLeftRed@3x.png';

import chevronLeftLightGrey from './icons/chevronLeftLightGrey.png';
import chevronLeftLightGrey2x from './icons/chevronLeftLightGrey@2x.png';
import chevronLeftLightGrey3x from './icons/chevronLeftLightGrey@3x.png';

import refreshOutlinedGrey from './icons/refreshOutlinedGrey.png';
import refreshOutlinedGrey2x from './icons/refreshOutlinedGrey@2x.png';
import refreshOutlinedGrey3x from './icons/refreshOutlinedGrey@3x.png';

import starOutlinedGrey from './icons/starOutlinedGrey.png';
import starOutlinedGrey2x from './icons/starOutlinedGrey@2x.png';
import starOutlinedGrey3x from './icons/starOutlinedGrey@3x.png';

import chevronDown from './icons/chevronDown.png';
import chevronDown2x from './icons/chevronDown@2x.png';
import chevronDown3x from './icons/chevronDown@3x.png';

import minus from './icons/minus.png';
import minus2x from './icons/minus@2x.png';
import minus3x from './icons/minus@3x.png';

import minusHovered from './icons/minusHovered.png';
import minusHovered2x from './icons/minusHovered@2x.png';
import minusHovered3x from './icons/minusHovered@3x.png';

import plus from './icons/plus.png';
import plus2x from './icons/plus@2x.png';
import plus3x from './icons/plus@3x.png';

import plusLightGrey from './icons/plusLightGrey.png';
import plusLightGrey2x from './icons/plusLightGrey@2x.png';
import plusLightGrey3x from './icons/plusLightGrey@3x.png';

import plusHovered from './icons/plusHovered.png';
import plusHovered2x from './icons/plusHovered@2x.png';
import plusHovered3x from './icons/plusHovered@3x.png';

import trashOutlinedRed from './icons/trashOutlinedRed.png';
import trashOutlinedRed2x from './icons/trashOutlinedRed@2x.png';
import trashOutlinedRed3x from './icons/trashOutlinedRed@3x.png';

import rubleOutlinedGreen from './icons/rubleOutlinedGreen.png';
import rubleOutlinedGreen2x from './icons/rubleOutlinedGreen@2x.png';
import rubleOutlinedGreen3x from './icons/rubleOutlinedGreen@3x.png';

import crossLightGrey from './icons/crossLightGrey.png';
import crossLightGrey2x from './icons/crossLightGrey@2x.png';
import crossLightGrey3x from './icons/crossLightGrey@3x.png';

import videoPlayIcon from './icons/videoPlayIcon.png';
import videoPlayIcon2x from './icons/videoPlayIcon@2x.png';
import videoPlayIcon3x from './icons/videoPlayIcon@3x.png';

import videoPlayIconHover from './icons/videoPlayIconHover.png';
import videoPlayIconHover2x from './icons/videoPlayIconHover@2x.png';
import videoPlayIconHover3x from './icons/videoPlayIconHover@3x.png';

import moonOutlinedDarkGrey from './icons/moonOutlinedDarkGrey.png';
import moonOutlinedDarkGrey2x from './icons/moonOutlinedDarkGrey@2x.png';
import moonOutlinedDarkGrey3x from './icons/moonOutlinedDarkGrey@3x.png';

import moonOutlinedLightGrey from './icons/moonOutlinedLightGrey.png';
import moonOutlinedLightGrey2x from './icons/moonOutlinedLightGrey@2x.png';
import moonOutlinedLightGrey3x from './icons/moonOutlinedLightGrey@3x.png';

import moonOutlinedWhite from './icons/moonOutlinedWhite.png';
import moonOutlinedWhite2x from './icons/moonOutlinedWhite@2x.png';
import moonOutlinedWhite3x from './icons/moonOutlinedWhite@3x.png';

import sunOutlinedLightGrey from './icons/sunOutlinedLightGrey.png';
import sunOutlinedLightGrey2x from './icons/sunOutlinedLightGrey@2x.png';
import sunOutlinedLightGrey3x from './icons/sunOutlinedLightGrey@3x.png';

import sunOutlinedDarkGrey from './icons/sunOutlinedDarkGrey.png';
import sunOutlinedDarkGrey2x from './icons/sunOutlinedDarkGrey@2x.png';
import sunOutlinedDarkGrey3x from './icons/sunOutlinedDarkGrey@3x.png';

import sunOutlinedWhite from './icons/sunOutlinedWhite.png';
import sunOutlinedWhite2x from './icons/sunOutlinedWhite@2x.png';
import sunOutlinedWhite3x from './icons/sunOutlinedWhite@3x.png';

let imageList = {
  // videoPlayIcon
  videoPlayIcon: {
    x1: videoPlayIcon,
    x2: videoPlayIcon2x,
    x3: videoPlayIcon3x
  },
  videoPlayIconHover: {
    x1: videoPlayIconHover,
    x2: videoPlayIconHover2x,
    x3: videoPlayIconHover3x
  },
  // crossLightGrey
  crossLightGrey: {
    x1: crossLightGrey,
    x2: crossLightGrey2x,
    x3: crossLightGrey3x
  },
  // ruble
  rubleOutlinedGreen: {
    x1: rubleOutlinedGreen,
    x2: rubleOutlinedGreen2x,
    x3: rubleOutlinedGreen3x
  },
  // trash
  trashOutlinedGrey: {
    x1: trashOutlinedGrey,
    x2: trashOutlinedGrey2x,
    x3: trashOutlinedGrey3x
  },
  trashOutlinedRed: {
    x1: trashOutlinedRed,
    x2: trashOutlinedRed2x,
    x3: trashOutlinedRed3x
  },
  // thumbs-down
  thumbsDownOutlinedGrey: {
    x1: thumbsDownOutlinedGrey,
    x2: thumbsDownOutlinedGrey2x,
    x3: thumbsDownOutlinedGrey3x
  },
  thumbsDownOutlinedRed: {
    x1: thumbsDownOutlinedRed,
    x2: thumbsDownOutlinedRed2x,
    x3: thumbsDownOutlinedRed3x
  },
  // thumbs-up
  thumbsUpOutlinedGrey: {
    x1: thumbsUpOutlinedGrey,
    x2: thumbsUpOutlinedGrey2x,
    x3: thumbsUpOutlinedGrey3x
  },
  thumbsUpOutlinedGreen: {
    x1: thumbsUpOutlinedGreen,
    x2: thumbsUpOutlinedGreen2x,
    x3: thumbsUpOutlinedGreen3x
  },
  // gift
  gift: {
    x1: gift,
    x2: gift2x,
    x3: gift3x
  },
  giftRed: {
    x1: giftRed,
    x2: giftRed2x,
    x3: giftRed3x
  },
  // minus
  minus: {
    x1: minus,
    x2: minus2x,
    x3: minus3x
  },
  minusHovered: {
    x1: minusHovered,
    x2: minusHovered2x,
    x3: minusHovered3x
  },
  minusLightGrey: {
    x1: minusLightGrey,
    x2: minusLightGrey2x,
    x3: minusLightGrey3x
  },
  // plus
  plus: {
    x1: plus,
    x2: plus2x,
    x3: plus3x
  },
  plusLightGrey: {
    x1: plusLightGrey,
    x2: plusLightGrey2x,
    x3: plusLightGrey3x
  },
  plusRed: {
    x1: plusRed,
    x2: plusRed2x,
    x3: plusRed3x
  },
  plusHovered: {
    x1: plusHovered,
    x2: plusHovered2x,
    x3: plusHovered3x
  },
  // chevron
  chevronDown: {
    x1: chevronDown,
    x2: chevronDown2x,
    x3: chevronDown3x
  },
  // Заглушка продуктовой карточки если ошибка
  productCardErrorImg: {
    x1: productCardErrorImg,
    x2: productCardErrorImg2x,
    x3: productCardErrorImg3x
  },
  // radio-button-on
  radioButtonOn: {
    x1: radioButtonOn,
    x2: radioButtonOn2x,
    x3: radioButtonOn3x
  },
  radioButtonOnGreen: {
    x1: radioButtonOnGreen,
    x2: radioButtonOnGreen2x,
    x3: radioButtonOnGreen3x
  },
  // chevron-left стрелка без палки влево
  chevronLeftRed: {
    x1: chevronLeftRed,
    x2: chevronLeftRed2x,
    x3: chevronLeftRed3x
  },
  chevronLeftLightGrey: {
    x1: chevronLeftLightGrey,
    x2: chevronLeftLightGrey2x,
    x3: chevronLeftLightGrey3x
  },
  // refresh
  refreshOutlinedGrey: {
    x1: refreshOutlinedGrey,
    x2: refreshOutlinedGrey2x,
    x3: refreshOutlinedGrey3x
  },
  // star
  starOutlinedGrey: {
    x1: starOutlinedGrey,
    x2: starOutlinedGrey2x,
    x3: starOutlinedGrey3x
  },
  // bookmark
  bookmarkOutlined: {
    x1: bookmarkOutlined,
    x2: bookmarkOutlined2x,
    x3: bookmarkOutlined3x
  },
  bookmarkOutlinedRed: {
    x1: bookmarkOutlinedRed,
    x2: bookmarkOutlinedRed2x,
    x3: bookmarkOutlinedRed3x
  },
  bookmarkFilledRed: {
    x1: bookmarkFilledRed,
    x2: bookmarkFilledRed2x,
    x3: bookmarkFilledRed3x
  },
  // checkmark
  checkSquareOutlined: {
    x1: checkSquareOutlined,
    x2: checkSquareOutlined2x,
    x3: checkSquareOutlined3x
  },
  checkSquareOutlinedRed: {
    x1: checkSquareOutlinedRed,
    x2: checkSquareOutlinedRed2x,
    x3: checkSquareOutlinedRed3x
  },
  checkmarkFilledCircleWhite: {
    x1: checkmarkFilledCircleWhite,
    x2: checkmarkFilledCircleWhite2x,
    x3: checkmarkFilledCircleWhite3x
  },
  checkmarkWhite: {
    x1: checkmarkWhite,
    x2: checkmarkWhite2x,
    x3: checkmarkWhite3x
  },
  // clock
  clockFilledWhite: {
    x1: clockFilledWhite,
    x2: clockFilledWhite2x,
    x3: clockFilledWhite3x
  },
  // person-done
  personDoneFilledDarkGrey: {
    x1: personDoneFilledDarkGrey,
    x2: personDoneFilledDarkGrey2x,
    x3: personDoneFilledDarkGrey3x
  },
  personDoneOutlinedLightGrey: {
    x1: personDoneOutlinedLightGrey,
    x2: personDoneOutlinedLightGrey2x,
    x3: personDoneOutlinedLightGrey3x
  },
  personDoneOutlinedRed: {
    x1: personDoneOutlinedRed,
    x2: personDoneOutlinedRed2x,
    x3: personDoneOutlinedRed3x
  },

  // shopping-bag
  shoppingbagFilledDarkGrey: {
    x1: shoppingbagFilledDarkGrey,
    x2: shoppingbagFilledDarkGrey2x,
    x3: shoppingbagFilledDarkGrey3x
  },
  // undo
  undoOutlinedDarkGrey: {
    x1: undoOutlinedDarkGrey,
    x2: undoOutlinedDarkGrey2x,
    x3: undoOutlinedDarkGrey3x
  },
  undoOutlinedRed: {
    x1: undoOutlinedRed,
    x2: undoOutlinedRed2x,
    x3: undoOutlinedRed3x
  },
  undoFilledCircleRed: {
    x1: undoFilledCircleRed,
    x2: undoFilledCircleRed2x,
    x3: undoFilledCircleRed3x
  },
  // award
  awardFilledGrey: {
    x1: awardFilledGrey,
    x2: awardFilledGrey2x,
    x3: awardFilledGrey3x
  },
  // cart
  cartFilledDarkGrey: {
    x1: cartFilledDarkGrey,
    x2: cartFilledDarkGrey2x,
    x3: cartFilledDarkGrey3x
  },
  // camera
  cameraOutlinedLightGrey: {
    x1: cameraOutlinedLightGrey,
    x2: cameraOutlinedLightGrey2x,
    x3: cameraOutlinedLightGrey3x
  },
  // alert
  alertCircleOrange: {
    x1: alertCircleOrange,
    x2: alertCircleOrange2x,
    x3: alertCircleOrange3x
  },
  // calendar
  calendarFilledDarkGrey: {
    x1: calendarFilledDarkGrey,
    x2: calendarFilledDarkGrey2x,
    x3: calendarFilledDarkGrey3x
  },
  checkmarkOutlinedGreen: {
    x1: checkmarkOutlinedGreen,
    x2: checkmarkOutlinedGreen2x,
    x3: checkmarkOutlinedGreen3x
  },
  // archive - архив
  archiveOutlined: {
    x1: archiveOutlined,
    x2: archiveOutlined2x,
    x3: archiveOutlined3x
  },
  archiveOutlinedRed: {
    x1: archiveOutlinedRed,
    x2: archiveOutlinedRed2x,
    x3: archiveOutlinedRed3x
  },
  // шляпа повара chief
  chiefHat: {
    x1: chiefHat,
    x2: chiefHat2x,
    x3: chiefHat3x
  },
  chiefHatRed: {
    x1: chiefHatRed,
    x2: chiefHatRed2x,
    x3: chiefHatRed3x
  },
  // инфо info
  infoOutlined: {
    x1: infoOutlined,
    x2: infoOutlined2x,
    x3: infoOutlined3x
  },
  // инфо
  info: {
    x1: info,
    x2: info2x,
    x3: info3x
  },
  infoRed: {
    x1: infoRed,
    x2: infoRed2x,
    x3: infoRed3x
  },
  infoGrey: {
    x1: infoGrey,
    x2: infoGrey2x,
    x3: infoGrey3x
  },
  // person
  personOutlined: {
    x1: personOutlined,
    x2: personOutlined2x,
    x3: personOutlined3x
  },
  // знак вопроса question
  questionCircled: {
    x1: questionCircled,
    x2: questionCircled2x,
    x3: questionCircled3x
  },
  questionCircledRed: {
    x1: questionCircledRed,
    x2: questionCircledRed2x,
    x3: questionCircledRed3x
  },
  questionCircledLightGrey: {
    x1: questionCircledLightGrey,
    x2: questionCircledLightGrey2x,
    x3: questionCircledLightGrey3x
  },
  // звезда
  starOutlined: {
    x1: starOutlined,
    x2: starOutlined2x,
    x3: starOutlined3x
  },
  starOutlinedRed: {
    x1: starOutlinedRed,
    x2: starOutlinedRed2x,
    x3: starOutlinedRed3x
  },
  starOutlinedLightGrey: {
    x1: starOutlinedLightGrey,
    x2: starOutlinedLightGrey2x,
    x3: starOutlinedLightGrey3x
  },
  // видео
  videoCircled: {
    x1: videoCircled,
    x2: videoCircled2x,
    x3: videoCircled3x
  },
  videoCircledRed: {
    x1: videoCircledRed,
    x2: videoCircledRed2x,
    x3: videoCircledRed3x
  },
  // весы weight
  weight: {
    x1: weight,
    x2: weight2x,
    x3: weight3x
  },
  weightRed: {
    x1: weightRed,
    x2: weightRed2x,
    x3: weightRed3x
  },
  // home
  homeOutlined: {
    x1: homeOutlined,
    x2: homeOutlined2x,
    x3: homeOutlined3x
  },
  // pin
  pinOutlined: {
    x1: pinOutlined,
    x2: pinOutlined2x,
    x3: pinOutlined3x
  },
  // сердечко лайк heart like
  heartOutlined: {
    x1: heartOutlined,
    x2: heartOutlined2x,
    x3: heartOutlined3x
  },
  heartFilled: {
    x1: heartFilled,
    x2: heartFilled2x,
    x3: heartFilled3x
  },
  heartFilledRed: {
    x1: heartFilledRed,
    x2: heartFilledRed2x,
    x3: heartFilledRed3x
  },
  // share
  shareOutlined: {
    x1: shareOutlined,
    x2: shareOutlined2x,
    x3: shareOutlined3x
  },
  shareFilled: {
    x1: shareFilled,
    x2: shareFilled2x,
    x3: shareFilled3x
  },
  shareFilledRed: {
    x1: shareFilledRed,
    x2: shareFilledRed2x,
    x3: shareFilledRed3x
  },
  // creditcard-income
  creditCardIncomeOutlined: {
    x1: creditCardIncomeOutlined,
    x2: creditCardIncomeOutlined2x,
    x3: creditCardIncomeOutlined3x
  },
  // creditcard-outcome
  creditCardOutcomeOutlinedRed: {
    x1: creditCardOutcomeOutlinedRed,
    x2: creditCardOutcomeOutlinedRed2x,
    x3: creditCardOutcomeOutlinedRed3x
  },
  creditCardOutcomeOutlinedGrey: {
    x1: creditCardOutcomeOutlinedGrey,
    x2: creditCardOutcomeOutlinedGrey2x,
    x3: creditCardOutcomeOutlinedGrey3x
  },
  creditCardOutcomeOutlinedGreen: {
    x1: creditCardOutcomeOutlinedGreen,
    x2: creditCardOutcomeOutlinedGreen2x,
    x3: creditCardOutcomeOutlinedGreen3x
  },
  // car
  carOutlined: {
    x1: carOutlined,
    x2: carOutlined2x,
    x3: carOutlined3x
  },
  // cart
  cartOutlined: {
    x1: cartOutlined,
    x2: cartOutlined2x,
    x3: cartOutlined3x
  },
  // колокол bell
  bellOutlined: {
    x1: bellOutlined,
    x2: bellOutlined2x,
    x3: bellOutlined3x
  },
  bellFilled: {
    x1: bellFilled,
    x2: bellFilled2x,
    x3: bellFilled3x
  },
  bellFilledRed: {
    x1: bellFilledRed,
    x2: bellFilledRed2x,
    x3: bellFilledRed3x
  },
  // edit
  editOutlinedGrey: {
    x1: editOutlinedGrey,
    x2: editOutlinedGrey2x,
    x3: editOutlinedGrey3x
  },
  editOutlinedRed: {
    x1: editOutlinedRed,
    x2: editOutlinedRed2x,
    x3: editOutlinedRed3x
  },
  editOutlinedLightRed: {
    x1: editOutlinedLightRed,
    x2: editOutlinedLightRed2x,
    x3: editOutlinedLightRed3x
  },
  // clock
  clockOutlinedRed: {
    x1: clockOutlinedRed,
    x2: clockOutlinedRed2x,
    x3: clockOutlinedRed3x
  },
  // moon
  moonOutlinedDarkGrey: {
    x1: moonOutlinedDarkGrey,
    x2: moonOutlinedDarkGrey2x,
    x3: moonOutlinedDarkGrey3x
  },
  moonOutlinedLightGrey: {
    x1: moonOutlinedLightGrey,
    x2: moonOutlinedLightGrey2x,
    x3: moonOutlinedLightGrey3x
  },
  moonOutlinedWhite: {
    x1: moonOutlinedWhite,
    x2: moonOutlinedWhite2x,
    x3: moonOutlinedWhite3x
  },
  // sun
  sunOutlinedLightGrey: {
    x1: sunOutlinedLightGrey,
    x2: sunOutlinedLightGrey2x,
    x3: sunOutlinedLightGrey3x
  },
  sunOutlinedDarkGrey: {
    x1: sunOutlinedDarkGrey,
    x2: sunOutlinedDarkGrey2x,
    x3: sunOutlinedDarkGrey3x
  },
  sunOutlinedWhite: {
    x1: sunOutlinedWhite,
    x2: sunOutlinedWhite2x,
    x3: sunOutlinedWhite3x
  }
};

export default imageList;
